import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import GenericButton from '../common/GenericButton';

const FunctionBoxButtonGroupV2 = ({
  moveAppendToCodingBox,
  moveToColumns,
  moveToRows,
  addToDefinitionModal,
  noExpressionBox,
  noCRB,
}) => {
  return (
    <Fragment>
      { !noExpressionBox && < div className="text-right">
        <GenericButton
          name="Move to Coding Box"
          btnStyle="button small button-100pt"
          onBtnClick={() => moveAppendToCodingBox(true)}
        />
        </div>
      }
      {!noExpressionBox && <div className="text-right">
        <GenericButton
          name="Append to Coding Box"
          btnStyle="button small button-100pt"
          onBtnClick={() => moveAppendToCodingBox(false)}
        />
      </div>
      }
      {!noCRB && <div className="text-right">
        <GenericButton
          name="Move to Columns"
          btnStyle="button small button-100pt"
          onBtnClick={moveToColumns}
        />
      </div>
      }
      {!noCRB && <div className="text-right">
        <GenericButton
          name="Move to Rows"
          btnStyle="button small button-100pt"
          onBtnClick={moveToRows}
        />
      </div>
      }
      <div className="text-right">
        <GenericButton
          name="Save to Definitions"
          btnStyle="button small button-100pt"
          onBtnClick={addToDefinitionModal}
        />
      </div>
    </Fragment>
  );
};

FunctionBoxButtonGroupV2.propTypes = {
  moveAppendToCodingBox: PropTypes.func,
  moveToRows: PropTypes.func,
  moveToColumns: PropTypes.func,
  addToDefinitionModal: PropTypes.func,
  noExpressionBox: PropTypes.bool,
  noCRB: PropTypes.bool,
};

export default FunctionBoxButtonGroupV2;